/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Day_Names_WednesdayInputs */

const fr_week_session_day_names_wednesday = /** @type {(inputs: Week_Session_Day_Names_WednesdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mer`)
};

/**

* @param {Week_Session_Day_Names_WednesdayInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_day_names_wednesday = /** @type {((inputs?: Week_Session_Day_Names_WednesdayInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Day_Names_WednesdayInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_day_names_wednesday(inputs)
});